import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Necesito hablar con mis padres?',
  a: 'No, podés sanar sin esa conversación.'
}, {
  q: '¿Esto reemplaza terapia?',
  a: 'No, es un sistema práctico, no terapia.'
}, {
  q: '¿Funciona en Argentina?',
  a: 'Sí, está adaptado al contexto real.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés garantía total de 7 días. Te devolvemos el 100% sin preguntas.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-5 px-5 bg-[#020617]" data-id="element-101">
      <div className="max-w-xl mx-auto" data-id="element-102">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-103">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-104">
          {faqs.map((faq, idx) => <div key={idx} className="bg-slate-900 border border-slate-800 rounded-xl overflow-hidden" data-id="element-105">
              <button className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-slate-800/50 focus:outline-none transition-colors" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-106">
                <span className="font-bold text-white text-sm pr-4" data-id="element-107">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="text-brand-yellow flex-shrink-0" size={18} data-id="element-108" /> : <ChevronDown className="text-gray-600 flex-shrink-0" size={18} data-id="element-109" />}
              </button>
              {openIdx === idx && <div className="px-5 pb-4 text-sm text-slate-400 leading-relaxed border-t border-slate-800" data-id="element-110">
                  <div className="pt-3" data-id="element-111">{faq.a}</div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}